import React, { useState } from 'react';
import { renderCloze } from '../utils/cloze';
import './ClozeCard.css';

export const ClozeCard = ({ card, direction, counter, onComplete }) => {
  const [revealed, setRevealed] = useState(false);
  const showArabic = direction === 'ar';
  const text = showArabic ? card.ar : card.en;

  const parts = renderCloze(text, revealed);

  const handleReveal = () => {
    setRevealed(true);
  };

  return (
    <div className="cloze-card">
      <div className="cloze-card-inner">
        <div className="cloze-card-header">
          <div className="cloze-card-header-left">
            <div className="cloze-card-label">
              {showArabic ? 'ARABIC' : 'ENGLISH'} - CLOZE
            </div>
            {card.dialect && <div className="dialect-badge">Dialect</div>}
          </div>
          <div className="cloze-card-counter">{counter}</div>
        </div>

        <div className="cloze-card-content">
          {card.image && (
            <div className="cloze-card-image-container">
              <img src={card.image} alt="Card visual" className="cloze-card-image" />
            </div>
          )}

          <div className={`cloze-text ${showArabic ? 'arabic' : ''}`} dir={showArabic ? 'rtl' : 'ltr'}>
            {parts.map((part) => {
              if (part.type === 'text') {
                return <span key={part.id}>{part.content}</span>;
              } else {
                // Cloze deletion
                return (
                  <span
                    key={part.id}
                    className={`cloze-blank ${part.revealed ? 'revealed' : ''}`}
                    title={part.revealed ? '' : 'Click "Show Answer" to reveal'}
                  >
                    {part.revealed ? part.content : '___'}
                  </span>
                );
              }
            })}
          </div>

          {card.tags && card.tags.length > 0 && (
            <div className="cloze-card-tags">
              {card.tags.map((tag, i) => (
                <span key={i} className="cloze-card-tag">{tag}</span>
              ))}
            </div>
          )}
        </div>

        <div className="cloze-card-footer">
          {!revealed ? (
            <button className="btn-show-answer" onClick={handleReveal}>
              Show Answer
            </button>
          ) : (
            <div className="cloze-card-actions">
              <button
                className="btn-cloze-action btn-wrong"
                onClick={() => onComplete('wrong')}
                title="I got it wrong"
              >
                ❌ Wrong
              </button>
              <button
                className="btn-cloze-action btn-hard"
                onClick={() => onComplete('hard')}
                title="Hard"
              >
                😓 Hard
              </button>
              <button
                className="btn-cloze-action btn-good"
                onClick={() => onComplete('good')}
                title="Good"
              >
                👍 Good
              </button>
              <button
                className="btn-cloze-action btn-easy"
                onClick={() => onComplete('easy')}
                title="Easy"
              >
                😊 Easy
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
